import { create } from 'zustand';
import type { ShortcutHelpSection } from '../hooks/use-editor-shortcuts';

// Lightweight registry so a deeply-nested editor can contribute its
// context-specific shortcut documentation to the single, app-level help
// overlay (see App.tsx + shortcuts-help.tsx). The editor publishes its grouped
// sections on mount/update and clears them on unmount, keeping one "?" overlay
// as the single source of truth instead of stacking editor-local modals.
interface ShortcutsStore {
  contextSections: ShortcutHelpSection[];
  contextTitle?: string;
  setContext: (sections: ShortcutHelpSection[], title?: string) => void;
  clearContext: () => void;
}

export const useShortcutsStore = create<ShortcutsStore>((set) => ({
  contextSections: [],
  contextTitle: undefined,
  setContext: (contextSections, contextTitle) => set({ contextSections, contextTitle }),
  clearContext: () => set({ contextSections: [], contextTitle: undefined }),
}));
